export function userAgentPlatform() {
  const userAgent = window.navigator.userAgent.toLowerCase();
  const safari = /safari/.test(userAgent);
  const ios = /iphone|ipod|ipad/.test(userAgent);
  const android = /android/.test(userAgent);

  if (ios && !safari) return "ios";
  if (android) return "android";
  return "web";
}
